import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown, Button } from 'semantic-ui-react'
import { getTranslations } from '../actions/language'
import { logOutToken } from '../actions/app_token'
import { getLanguageOptions, getText } from '../helpers';
import ObjectITButton from './developed_by_objectit';

function verifySelectedLanguage(languageName) {
  // TODO: fix language service in the backend to accomodate new languages.
  // This will just ensure the correct selected language in dropdown, because
  // the api always returns english value if the selected langauge (languageName) is not english, spanish or turkish.
  return localStorage.getItem('language') || languageName
}

class AppHeader extends Component {
  constructor(props){
    super(props);
    this.state = {
      languages: getLanguageOptions(),
      translations: this.props.language.translations,
      languageName: this.props.language.name,
    }
  }

  componentDidMount = () => {
    let language = "English";

    if (this.props.showLanguage) {
      language = verifySelectedLanguage(this.state.languageName)
    }

    this.props.getTranslations(language);
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.language !== this.props.language){
      this.setState({
        translations: nextProps.language.translations,
        languageName: nextProps.language.name,
      })
    }
  }

  onLanguageChange = (evt, obj) => {
    const selectedLanguage = verifySelectedLanguage(this.state.languageName)
    
    if (selectedLanguage === obj.value){
      return
    }
    localStorage.setItem('language', obj.value);
    this.forceUpdate();
    this.props.getTranslations(obj.value)
  }

  render() {
    const { toggleSideBar, editPlanName, updatePlanName, notifications, planName, handleNameChange, showLogout, view,
            showLoading, showNoActivities, pendingMessage, showMenuButton, showLanguage } = this.props
    const { system_title, edit_plan_tooltip, save_plan_tooltip, select_language, logout, fetching_activities, no_activities,
          files, admin_view, manage_users, plan_context } = this.state.translations ? this.state.translations : {}
    const { languages, languageName } = this.state
    var titleStyle = (!showMenuButton && !showLogout) ? { width: "calc(100% - 180px)", paddingLeft: '180px' } : {}
    titleStyle = (showMenuButton && !showLanguage) ? { width: "calc(100% - 168px)" } : titleStyle
    var languageStyle = (!showLogout) ? { margin: '0px' } : {}
    const {permission} = this.props
    const selectedLanguage = verifySelectedLanguage(languageName)
    const isLoggedIn = this.props.token;
  
    return (
      <header className="App-header">
        { showMenuButton &&
          <i className="bars icon" onClick={() => toggleSideBar()}></i>
        }
        <h1 className="App-title" style={titleStyle}>
          {
            ['users', 'admin-dashboard', 'admin-template', 'control-library'].includes(view) &&
            <span><span style={{color: '#ff1e1e'}}>{admin_view}</span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>
          }
          <span>{system_title}</span>
          { planName !== undefined && ['table', 'admin-template'].includes(view) &&
            <span id="static-name">
              <span className="plan-name">- {planName}</span>
              { permission && permission.can_update && <i onClick={() => editPlanName()} className="edit icon edit-button" title={edit_plan_tooltip}></i>}
            </span>
          }
          { planName !== undefined && ['table', 'admin-template'].includes(view) &&
            <span className="ui input" id="editable-name"> -
              <input type="text" value={ planName || '' } onChange={ (evt) => handleNameChange(evt) }></input>
              { permission && permission.can_update && <i onClick={() => updatePlanName()} className="save icon save-button" title={save_plan_tooltip}></i>}
            </span>
          }

          { ['table', 'admin-template'].includes(view) &&
            <span id="notifications">&nbsp;&nbsp;{notifications}</span>
          }

          { ['table', 'admin-template'].includes(view) && showLoading &&
            <span id="static-loading">&nbsp;&nbsp;<i className="loading circle notched icon"></i>{ fetching_activities }</span>
          }

          { planName !== undefined && view === 'cards' &&
            <span id="static-name">
              <span className="plan-name">- { planName }</span>
            </span>
          }
          { view === 'cards' && showLoading &&
            <span id="static-loading">
              <span><i className="loading circle notched icon"></i>{ fetching_activities }</span>
            </span>
          }

          { view === 'cards' && showNoActivities &&
            <span>&nbsp;&nbsp;{no_activities}</span>
          }

          { view === 'users' &&
            <span> - {manage_users}&nbsp;&nbsp;</span>
          }

          { ['dashboard', 'admin-dashboard'].includes(view) &&
            <span> - {files}&nbsp;&nbsp;</span>
          }

          { ['dashboard', 'admin-dashboard'].includes(view) &&
            <span id="notifications">{notifications}</span>
          }

          { ['dashboard', 'admin-dashboard'].includes(view) &&
            <span id="create-notification">
              <span><i className="loading circle notched icon"></i> {pendingMessage}</span>
            </span>
          }

          {
            view == 'control-library' && <span> - {getText("Control Library")}</span>
          }

        </h1>

        { showLanguage &&
          <Dropdown
            style={languageStyle}
            className="language"
            placeholder={select_language}
            fluid
            selection
            options={ languages }
            value={ selectedLanguage }
            onChange={ this.onLanguageChange }
          />
        }

        { showLogout &&
          <Button color='red' fluid size='medium' onClick={() => this.props.logout(this.props.token)} className="log-out-button">{logout}</Button>
        }

        {!isLoggedIn && (
          <span className="navbar-image">
            <ObjectITButton />
          </span>
        )}
      </header>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    language: state.language.language
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (token) => {
      dispatch(logOutToken(token))
    },
    getTranslations: (name) => {
      dispatch(getTranslations(name))
    }
  }
}

let SystemHeader = connect(mapStateToProps, mapDispatchToProps)(AppHeader)
export default SystemHeader



// WEBPACK FOOTER //
// ./src/components/system_header.js